import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InfoSnackbarComponent } from './info-snackbar/info-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  readonly snackbar = inject(MatSnackBar);

  show(text: string, duration = 3000) {
    const snackbarRef = this.snackbar.openFromComponent(InfoSnackbarComponent, {
      duration: duration,
      data: { text: text, close: () => snackbarRef.dismiss() },
    });
  }
}
